import { render, staticRenderFns } from "./QuestionSlot.vue?vue&type=template&id=6ed096d6&scoped=true"
import script from "./QuestionSlot.vue?vue&type=script&lang=ts"
export * from "./QuestionSlot.vue?vue&type=script&lang=ts"
import style0 from "./QuestionSlot.vue?vue&type=style&index=0&id=6ed096d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed096d6",
  null
  
)

export default component.exports